export default "__VITE_PUBLIC_ASSET__95c671ae__"